import React from 'react';
import { ClockIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { CONSTANTS } from '../utils/constants';
export const UrgencySection: React.FC = () => {
  return <section className="py-10 px-4 bg-red-50 border-y border-red-100" data-id="element-305">
      <div className="max-w-3xl mx-auto text-center" data-id="element-306">
        <div className="flex justify-center mb-4" data-id="element-307">
          <ClockIcon className="w-12 h-12 text-red-600 animate-pulse" data-id="element-308" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-red-600 mb-4" data-id="element-309">
          Esta oferta especial desaparece pronto
        </h2>
        <p className="text-lg text-gray-700 mb-8" data-id="element-310">
          El descuento del {CONSTANTS.PRICING.SAVINGS_PERCENTAGE}% y los 6 bonos
          gratuitos solo están disponibles durante el tiempo que marca este
          contador.
        </p>

        <div className="flex justify-center" data-id="element-311">
          <CountdownTimer variant="red" data-id="element-312" />
        </div>
      </div>
    </section>;
};